import MainTestScenario from './MainTestScenario';
import { constants, Globals } from '../../../../misc/helpers';
import Tools from '../../../../core/Misc/Tools';
import { ScenarioSceneType } from '../../../../misc/BleedingControlScenario';

export default class MainTestScenarioSteps9And10And11 {
	private numberOfTightens = 0;
	constructor(private mainScenario: MainTestScenario, private onDone: (aarReady9: boolean) => void, public showFailedAar: () => void) {
	}

	start() {
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});

		this.step1TwistRod();
	}

	private step1TwistRod() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to twist the rod?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps9And10And11.step1TwistRod', () => context.step1TwistRodYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step1TwistRodNo()
			}
		});
	}

	private step1TwistRodYes() {
		if(!this.mainScenario.aarPressureDressingNotRemoved) {
			this.mainScenario.playSequence('SetBloodParticlePercentage', {
				zeroPercent: false,
				twentyFivePercent: true,
				fiftyPercent: false,
				seventyFivePercent: false,
				oneHundredPercent: false
			});
		}
		this.step2StartTourniqueteRotationInteraction();
	}

	private step1TwistRodNo() {
		this.step3HasBleedingStopped();
		// var context = this;
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1TwistRod());
	}

	private step2StartTourniqueteRotationInteraction() {
		var context = this;
		setTimeout(() => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-9', '1', () => {
				this.mainScenario.playSound('Step-9', '2', () => {
					this.mainScenario.playSound('Step-9', '3', () => {
						context.mainScenario.playSequence('VictimStopLips');
						this.mainScenario.playSound('Step-9', '4', () => {
						});
					});
				});
			});
		}, 2000);

		//var numberOfTurns = Tools.randomInteger(3, 4); 
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.TourniqueteRotation, {
			dispatch: context.mainScenario.gameManager.customData.dispatch,
			onUpdate: (percentage: number, greenColorPercentage: number) => {
				if(percentage >= greenColorPercentage) {
					setTimeout(() => {
						context.step3HasBleedingStopped();
					}, 500);
				}
			}
		});
	}

	private step3HasBleedingStopped() {
		var context = this;
			this.mainScenario.aarTwistFirstTourniqueteRod = true;

		if((context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioB　|| context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioA) && (context.mainScenario.incorrectPathChosen === false)) {
			context.mainScenario.stopBleeding();
		}
		if(context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioB　|| context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioA) {
			Globals.stopTimer = true;
		}
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Has the bleeding stopped?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps9And10And11.step3HasBleedingStopped', () => context.step3HasBleedingStoppedYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step3HasBleedingStoppedNo()
			}
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
			dispatch: context.mainScenario.gameManager.customData.dispatch,
			TournPivot: true
		});
	}

	private step3HasBleedingStoppedNo() {
		this.mainScenario.moveToTourniquetLocation();
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		if(context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioB　|| context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioA) {
			this.mainScenario.aarReassessAfterFirstTourniquete = false;
		}
		else {
			this.mainScenario.aarReassessAfterFirstTourniquete = true;
		}

		this.mainScenario.playSound('Step-10', '1', () => {
			this.mainScenario.playSound('Step-10', '2', () => {
			context.step4TightenTourniqueteMore();
});
});
	}

	private step3HasBleedingStoppedYes() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		if(context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioB　|| context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioA) {
			this.mainScenario.aarReassessAfterFirstTourniquete = true;
		}
		else {
			this.mainScenario.aarReassessAfterFirstTourniquete = false;
		}
		context.step4TightenTourniqueteMore();
		this.mainScenario.playSound('Step-10', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');

			this.mainScenario.playSound('Step-10', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');

});
});

		// var context = this;
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3HasBleedingStopped());
	}

	private step4TightenTourniqueteMore() {
		this.mainScenario.moveToTourniquetLocation();
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to tighten the tourniquet more?',
			correctButton: {
				title: 'Yes',
				onClick: () => {
					context.numberOfTightens++;
					if(context.numberOfTightens > 1) {
						context.mainScenario.showJITFeedback('The tourniquete can not be tightened any further', () => context.step4TightenTourniqueteMore());
					} else {
						context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps9And10And11.step4TightenTourniqueteMore', () => context.step4TightenTourniqueteMoreYes())
					}
				}
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step4TightenTourniqueteMoreNo()
			}
		});
	}

	private step4TightenTourniqueteMoreNo() {
		this.mainScenario.moveToTourniquetLocation();
		this.mainScenario.playSequence('TourniquetLock');
		this.step5FinishTourniqueteAnimation();
	}

	private step4TightenTourniqueteMoreYes() {
		this.step2StartTourniqueteRotationInteraction();
	}

	private step5FinishTourniqueteAnimation() {
		var context = this;
		context.mainScenario.aarRecordTimeOfFirstTourniquete = true;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.playSound('Step-10', '3', () => {
		//context.mainScenario.playSequence('Steps9And10And11Cinematic', null, () => {
			context.onDone(true);
		//});
	});
	}
}